// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__1f-17","text":"style_text__3uPRP","poweredImg":"style_poweredImg__1yTDW"};